import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import beianIcon from '../备案图标.png';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'primary.main',
        color: 'white',
        py: 2,
        mt: 'auto',
        borderTop: '1px solid rgba(255, 255, 255, 0.12)',
      }}
    >
      <Container maxWidth="lg">
        <Typography variant="body2" align="center" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

          <Box component="span" sx={{ ml: 1, display: 'flex', alignItems: 'center' }}>
            <img src={beianIcon} alt="备案图标" style={{ width: '16px', height: '16px', marginRight: '4px' }} />
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=33010802014284" rel="noreferrer" target="_blank">浙公网安备33010802014284号</a>
          </Box>
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
